import { FactoryProvider, Provider } from "@angular/core";
import { Constructor, isset } from "@cawita/core-front";
import { CwtApiService } from "@cawita/core-front/api";
import { getModelConfig } from "./crud.decorator";
import { GenericCrudService } from "./crud.service";


function formatCrudProviderKey(name: string) {
    return `cwt-crud-${name}`;
}

export function getCrudName<D>(constructor: Constructor<D>): string {
    const config = getModelConfig(constructor);
    if (!isset(config?.name)) throw new Error(`Model ${constructor.name} has not been decorated`);
    return formatCrudProviderKey(config.name);
}

export function provideCrud<D>(constructor: Constructor<D>): FactoryProvider {
    const config = getModelConfig(constructor);
    if (!isset(config?.name)) throw new Error(`Model ${constructor.name} has not been decorated`);
    return {
        provide: formatCrudProviderKey(config?.name),
        deps: [CwtApiService],
        useFactory: (api: CwtApiService) => new GenericCrudService(api, config?.path, constructor)
    };
}


export function provideCruds(models: Constructor<any>[]): Provider[] {
    return models.filter(m => isset(getModelConfig(m)?.name)).map(model => provideCrud(model));
}